export const formatLabel = (label: string, value: string[] | string): string => {
	if (Array.isArray(value)) {
		return `${label} (${value?.length || 0})`;
	}
	return label;
};
